<template>
  <div>
    <div ref="h_top">
      <van-nav-bar class="bg-gradual-blue" title="场馆预约" />
      <van-dropdown-menu ref="bar">
        <van-dropdown-item @change="initQuery" v-model="value1" :options="option1" />
        <van-dropdown-item @change="initQuery" v-model="value2" :options="option2" />
      </van-dropdown-menu>
    </div>
    
    <div ref="h_cont" style="margin:0 5px;overflow-y: auto;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadList">
        <div style="margin-top: 5px;background-color: #FFFFFF;padding: 10px;border-radius: 5px;" v-for="item in cgList" @click="NextStep(item)">
          <van-row type="flex" justify="space-between">
            <van-col span="16" gutter="20" type="flex">
              <van-row>
                <van-col span="24" style="padding: 5px;color:blue;font-size: 18px;">{{item.name}}</van-col>
              </van-row>
              <van-row>
                <van-col span="24" style="padding: 5px;color:#000000;font-size: 14px;">{{item.schoolName}} {{item.libraryName}} {{item.positionDesc}}</van-col>
              </van-row>
              <van-row>
                <van-col span="24" style="padding: 5px;color:#999;font-size: 14px;">{{item.sroomDesc}}</van-col>
              </van-row>
            </van-col>
            <van-col span="8" type="flex" style="margin: auto;">
              <van-image :src="item.imgUrl" />
            </van-col>
          </van-row>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { loadData } from '@/utils/common'
import Seat from '@/utils/seat'
import { Toast } from 'vant';

export default {
  props: {
    rdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      value1: '',
      value2: '',
      option1: [
        { text: '全部校区', value: '' },
        { text: '中校区', value: '1' },
      ],
      option2: [
        { text: '全部类型', value: '' },
        { text: '会议室', value: '1' },
		{ text: '舞台', value: '2' }
      ],
      start:1,
      limit:10,
      cgList:[],
      list: [],
      loading: false,
      finished: false,    
	  isQuery:false
    }
  },
  mounted() {
    this.initScreenH();
  },
  methods: {
    initScreenH(){
      let fh = document.documentElement.clientHeight;
      let bh = this.$store.state.bottomH;
      let th = this.$refs.h_top.offsetHeight;
      this.$refs.h_cont.style.height = (fh - th - bh)+'px';
    },
    initQuery(){
      this.cgList = [];
	  console.log(JSON.stringify(this.cgList));
      this.start = 1;
      this.finished = false;
      this.loadList();
    },
    loadList(){
	  if(this.isQuery){
		  return;
	  }
	  this.isQuery = true;
      var paramsJson = {
        "schoolId": this.value1,
        "rtype": this.value2,
        "page": this.start,
        "limit": this.limit
      }
      loadData('/appCg/queryCgList',paramsJson).then(response => {
        if(response && response.code == 0){
          let tList = response.data.list;
          for(let i = 0;i < tList.length;i++){
            this.cgList.push(tList[i]);
          }
          this.start = response.data.prePage + 1;
          this.finished = response.data.isLastPage;
          this.loading = false;
		  this.isQuery = false;
        }
      }).catch(() => {
		  this.isQuery = false;
        //this.listLoading = false
      })
    },
    NextStep(sroom){
     // this.$emit("notice",  {'page':'list','sroom':sroom})
      Toast('目前在改造暂停预约，开放预约时间另行通知！');
    }
  }
}
</script>

<style>

/* 111 */
.service-list{
  padding: 0 5px;
}
.service-item{
  display: flex;
  padding: 5px; 
  background-color: #fff;
  margin-top:10px;
  border-bottom:1px dashed #ccc;
}
.service-img{
  width: 40%;
  max-height: 100px;
}
.service-item image{
  width: 100%;
  max-height: 100px;
}
.service-text{
  flex: 1;
  margin-left: 10px;
  width: 100%;
}
.service-text .service-tite{
  color: #333;
  width: 100%;
  font-size: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.service-tags{
  margin: 3px 0;
  padding: 3px 8px;
  border: 1px solid #f7982a;
  line-height: 1;
  color: #f7982a;
  font-size: 14px;
  border-radius: 2px;
  margin-right: 5px;
  margin-bottom: 5px;
  white-space: nowrap;
}
.service-city{
  color: #666;
}

.filter-tab{
  display: flex;
  width: 100%;
  line-height: 40px;
  border-bottom: 1px solid #ddd;
  position: relative;
  z-index: 2;
  background: #fff;
}
.filter-tab text{
  flex: 1;
  text-align: center;
}
.filter-tab text:after{
  content: '';
  display: inline-block;
  vertical-align: 2px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #bbb;
  margin-left: 4rpx;
}
.filter-tab text.active{
  color: #f7982a;
}
.filter-tab:not(.sort-tab) text.active:after{
  border-top: 0;
  border-bottom: 4px solid #f7982a;
}
.filter-tab.sort-tab text.active:after{
  border-top: 6px solid #f7982a;
}
.filter-panel{
  display: flex;
  background: #f5f5f5;
  position: absolute;
  width: 100%;
  z-index: 13;
  overflow: hidden;
}
.filter-panel-left,.filter-panel-right{
  flex: 1;
  line-height: 80rpx;
  text-align: center;
  max-height: 480rpx;
  overflow-y: auto;
}
.filter-panel-left .active{
  background: #fff;
}
.filter-panel-right .active{
  color: #f7982a;
}
.filter-panel-right{
  background: #fff;
}
.filter-panel-right:empty{
  display: none;
}
.filter-shadow{
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0,0,0,.5);
}

</style>
